<script setup lang="ts">
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { MButton } from '../M';

const emit = defineEmits<{
  (e: 'click'): void;
}>();

defineProps<{
  label: string;
}>();

const handleClick = () => {
  window.location.href = '/auth/redirect/linkedin';
  emit('click');
};
</script>

<template>
  <MButton
    :label="label"
    variant="outlined"
    color="secondary"
    @click="handleClick"
  >
    <template #leading>
      <FontAwesomeIcon :icon="faLinkedin" />
    </template>
  </MButton>
</template>
